module.exports = __webpack_public_path__ + "static/media/utility.1c627c73.png";